'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = metricsService;

var _tuneInRequest = require('../tuneInRequest');

var _tuneInRequest2 = _interopRequireDefault(_tuneInRequest);

var _isServer = require('../utils/isServer');

var _isServer2 = _interopRequireDefault(_isServer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function metricsService(config, apiContext, applyReauth) {
  var metricsEndpoint = config.domains.local + '/metrics';
  var loopback = '' + config.domains.loopback + metricsEndpoint;
  var loopbackOrProxyEndpoint = (0, _isServer2.default)() ? loopback : metricsEndpoint;

  function getMetricsAuthorization() {
    return (0, _tuneInRequest2.default)({
      method: 'get',
      url: loopbackOrProxyEndpoint + '/authorization/',
      disableRetry: true
    }, apiContext);
  }

  return {
    getMetricsAuthorization: applyReauth(getMetricsAuthorization)
  };
}
//# sourceMappingURL=metrics.js.map